import { useEffect } from "react"

import { Flex, Typography } from "antd"
import { t } from "i18next"
import { useNavigate } from "react-router"

import ButtonComponent from "../../Components/Button"
import Icon from "../../Icon"
import Earnings from "./Earnings"

const { Text } = Typography

const EarningsAdminPage = () => {
  const navigate = useNavigate()

  const goBack = () => {
    navigate("/referral")
  }

  useEffect(() => {
    document.title = "Rewards details & activity"
  }, [])

  return (
    <Flex className="admin-earnings-page" vertical gap={24}>
      <Flex gap={8} align="center">
        <ButtonComponent
          type="text"
          icon={<Icon type="arrow_left" />}
          style={{ width: 32 }}
          onClick={goBack}
        />
        <Text strong style={{ fontSize: 18, lineHeight: 1.4 }}>
          {t("Rewards details & activity")}
        </Text>
      </Flex>
      <Earnings />
    </Flex>
  )
}

export default EarningsAdminPage
